"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialData = void 0;
const react_1 = require("react");
const useCurrentPage_1 = require("./useCurrentPage");
const react_redux_1 = require("react-redux");
const initData_1 = require("@/Redux/Actions/initData");
const usePrevious_1 = __importDefault(require("./usePrevious"));
const useInitialData = () => {
    const page = (0, useCurrentPage_1.useCurrentPage)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const initialData = (0, react_redux_1.useSelector)((state) => state.initialData);
    const previousPage = (0, usePrevious_1.default)(page);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (initialData === null || initialData === void 0 ? void 0 : initialData.language) {
            return;
        }
        if (page && JSON.stringify(page) !== JSON.stringify(previousPage)) {
            dispatch((0, initData_1.fetchInitial)((_b = (_a = page.contentLink) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()));
        }
    }, [page, initialData]);
    return initialData;
};
exports.useInitialData = useInitialData;
exports.default = exports.useInitialData;
